import "@grapecity/wijmo.cultures/wijmo.culture.ja";
import "@grapecity/wijmo.styles/wijmo.css";
import "gestalt/dist/gestalt.css";
import { Stack } from "office-ui-fabric-react";
import React from "react";
import { GlobalHotKeys } from "react-hotkeys";
import "./assign-page.css";
import { AssignCommandBar } from "./components/assign-command-bar/AssignCommandBarContainer";
import { AssignFilter } from "./components/assign-filter/AssignFilterContainer";
import { AssignListContainer } from "./components/assign-list/AssignListContainer";
import { SidePanelContainer } from "./components/side-panel/SidePanelContainer";

/**
 * Props
 */
export interface AssignPageProps {
  /* State */
  diff: any;
  /* Action */
  USER_INSERT_ASSIGN: () => void;
  USER_DELETE_ASSIGN: () => void;
  onAssignSaveButtonClick: () => void;
  USER_RELOAD_ASSIGNS_LIST: () => void;
}

/**
 * アサイン画面
 * @param props
 * @constructor
 */
export const AssignPage = (props: AssignPageProps) => {
  // ショートカットキー設定
  const keyMap = {
    HOT_KEY_RELOAD_ASSIGNS_LIST: "command+f",
    HOT_KEY_INSERT_ASSIGNS: "command+i",
    HOT_KEY_DELETE_ASSIGNS: "command+d",
    HOT_KEY_SAVE_ASSIGNS: "command+s"
  };
  const handlers = {
    HOT_KEY_RELOAD_ASSIGNS_LIST: () => console.log("フォーカス当てたい"),
    HOT_KEY_INSERT_ASSIGNS: () => props.USER_INSERT_ASSIGN(),
    HOT_KEY_DELETE_ASSIGNS: () => props.USER_DELETE_ASSIGN(),
    HOT_KEY_SAVE_ASSIGNS: () => props.onAssignSaveButtonClick()
  };

  return (
    <>
      <GlobalHotKeys keyMap={keyMap} handlers={handlers} />
      <AssignCommandBar />
      <AssignFilter />
      <Stack horizontal={true} horizontalAlign="start">
        <AssignListContainer />
        <SidePanelContainer />
      </Stack>
    </>
  );
};

export default AssignPage;
